
import Enumerable from "linq";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { IItem, AbstractOptionSelectableTextItem, TextItemOption } from "../../../../../../../domain/document/items";
import {
  instanceOfIWizardObjectReferable,
  instanceOfIWizardObjectPositionSpecifiable,
  instanceOfIWizardObjectAlternativeOptionsSelectable,
  instanceOfIWizardObjectAlternativeOption,
  IWizardObjectAlternativeOption,
  instanceOfIWizardObjectOptionsVisibilitySpecifiable,
} from "../../../../../../../domain/format";
import { EditingDocument } from "../../../..";
import { FatalIndicator } from "../common";
import { TextItemOptionValueAccessor } from "../accessors";
import { default as ContentMixin } from "./ContentMixin.vue";

@Component({
  components: {
    WizardContent: () => import("../WizardContent.vue"),  // 再帰的に呼ばれるコンポーネントは動的import要.(単一コンポーネントでの再帰ならname指定でも回避可能？)
    FatalIndicator,
  },
})
export default class ObjectOptionSelectableMixin extends Mixins(ContentMixin) {
  data() {
    return {
      accessor: null as TextItemOptionValueAccessor,
      error: "",
    };
  }
  accessor: TextItemOptionValueAccessor;
  error: string;

  mounted() {
    this.initialize(this.item);
  }

  get isFatal(): boolean {
    return !this.accessor;
  }

  get item(): IItem {
    return this.readPropertyOrDefault(s => {
      const content = this.content;
      return instanceOfIWizardObjectReferable(content)
        ? Enumerable.from((s as EditingDocument).itemSets[0].items).firstOrDefault(i => i && (i.id === content.objectIdentifier.id))
        : null;
    }, null);
  }

  get isHorizontal(): boolean {
    return instanceOfIWizardObjectPositionSpecifiable(this.content) && this.content.isHorizontal;
  }

  get optionsClassName(): string {
    return this.isHorizontal
      ? "horizontal"
      : "";
  }

  get alternativeOptions(): IWizardObjectAlternativeOption[] {
    return instanceOfIWizardObjectAlternativeOptionsSelectable(this.content) && this.content.alternativeOptions && this.content.alternativeOptions.length > 0
      ? this.content.alternativeOptions.filter(o => instanceOfIWizardObjectAlternativeOption(o))
      : [];
  }

  get options(): TextItemOption[] {
    const options = this.item instanceof AbstractOptionSelectableTextItem
      ? this.item.options.filter(o => !!o.text).map(t => t)
      : [];
    return instanceOfIWizardObjectOptionsVisibilitySpecifiable(this.content) && this.content.visibleOptionIndexes && this.content.visibleOptionIndexes.length > 0
      ? this.content.visibleOptionIndexes.filter(i => i >= 0 && i < options.length).map(i => options[i])
      : options;
  }

  get selectedOption(): TextItemOption {
    return Enumerable.from(this.options).firstOrDefault(o => o.isSelected);
  }

  set selectedOption(option: TextItemOption) {
    this.options.forEach(o => o.isSelected = (o.text === option.text));
    this.updateItem(this.accessor.set(option), 0);
  }

  initialize(newValue: IItem) {
    try {
      this.accessor = new TextItemOptionValueAccessor(newValue);
      this.accessor.validate();
      this.error = "";
    } catch (e) {
      this.accessor = null;
      this.error = e.message;
    }
  }

  getAlternativeOption(index: number): IWizardObjectAlternativeOption {
    return Enumerable.from(this.alternativeOptions).firstOrDefault(o => o.index === index && !!o.text);
  }

  getOptionText(option: TextItemOption, index: number): string {
    const alternativeOption = this.getAlternativeOption(index);
    return alternativeOption
      ? alternativeOption.text
      : option.text;
  }

  @Watch("item")
  onItemUpdated(newValue: IItem) {
    this.initialize(newValue);
  }
}
